// JavaScript Document

// ============================================== INIT MAP ==============================================
function initialize(codeLanguage,myLat,myLng) {
	
  var stylez = [
  {
    featureType: "administrative",
    stylers: [
      { saturation: -100 }
    ]
  },{
    featureType: "landscape",
    stylers: [
      { saturation: -100 }
    ]
  },{
    featureType: "poi",
    stylers: [
      { saturation: -100 },
      { lightness: 77 }
    ]
  },{
    featureType: "transit",
    stylers: [
      { saturation: -100 }
    ]
  },{
    featureType: "water",
    stylers: [
      { hue: "#0088ff" },
      { lightness: -20 }
    ]
  },{
    featureType: "road",
    stylers: [
      { hue: "#00ff19" },
      { saturation: -100 },
      { lightness: 18 }
    ]
  },{
  }
];
	
	
	var myLatLng = new google.maps.LatLng(myLat, myLng);	
	  
	var myOptions = {
		  zoom: 15,
		  center: myLatLng,
			zoomControlOptions: {
				style: google.maps.ZoomControlStyle.LARGE
			},
			streetViewControl: false,
		  mapTypeId: google.maps.MapTypeId.ROADMAP
	};
	var map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
  
  var image = 'img/pointeur.png';
  var marker = new google.maps.Marker({
	  position: myLatLng, 
	  map: map,
	  icon: image
  });
  
	google.maps.event.addListener(marker, 'click', function() {
		infowindow.open(map,marker);
	});

  var styledMapOptions = {
      name: "mcube"
  }

  var jayzMapType = new google.maps.StyledMapType(stylez, styledMapOptions);

  map.mapTypes.set('mcube', jayzMapType);
  map.setMapTypeId('mcube');
	
}

// ============================================== INIT MAP ==============================================
